import { META_IMAGE } from '@shared/constants/constants';
import ImageHighest from '@images/adoption-index/ratings-highest.svg';
import ImageLowest from '@images/adoption-index/ratings-lowest.svg';
import ImageTop from '@images/adoption-index/header-top-desktop.svg';
import ImageBottom from '@images/adoption-index/header-bottom-desktop.svg';
import ImageTopMobile from '@images/adoption-index/header-top-mobile.svg';
import ImageBottomMobile from '@images/adoption-index/header-bottom-mobile.svg';

export const YEAR_PERIOD_2023 = '2023';
export const YEAR_PERIOD_2022 = '2022';
export const YEAR_PERIOD_2021 = '2021';
export const YEAR_PERIOD_2020 = '2020';
const COUNTRY_COUNT = 86;

export const ADOPTION_TABLE_DATA = (t) => ({
  tableTitle: t('vpnAdoptionIndex:adoptionTable.title'),
  tableText: t('vpnAdoptionIndex:adoptionTable.description', {
    yearPeriodFrom: YEAR_PERIOD_2020,
    yearPeriodTo: YEAR_PERIOD_2023,
  }),
  labels: {
    position: t('vpnAdoptionIndex:adoptionTable.labels.positionAbbr'),
    country: t('vpnAdoptionIndex:adoptionTable.labels.country'),
    downloads: t('vpnAdoptionIndex:adoptionTable.labels.downloads'),
    population: t('vpnAdoptionIndex:adoptionTable.labels.population'),
    vpnAdoptionIndex: t('vpnAdoptionIndex:adoptionTable.labels.vpnAdoptionIndex'),
  },
  infoText: t('vpnAdoptionIndex:adoptionTable.infoText', {
    yearPeriodFrom: YEAR_PERIOD_2020,
    yearPeriodTo: YEAR_PERIOD_2023,
  }),
  countryData: [
    {
      position: 1,
      country: 'Qatar',
      downloads_primary: 2012318,
      downloads_secondary: 1129081,
      downloads_tertiary: 2007756,
      downloads_quaternary: 1528763,
      population: 2880000,
      adoption_primary: 69.87,
      adoption_secondary: 39.2,
      adoption_tertiary: 69.69,
      adoption_quaternary: 53.06,
      iso: 'QA',
    },
    {
      position: 2,
      country: 'United Arab Emirates',
      downloads_primary: 6101770,
      downloads_secondary: 4270047,
      downloads_tertiary: 5886566,
      downloads_quaternary: 6093301,
      population: 9890000,
      adoption_primary: 61.7,
      adoption_secondary: 43.18,
      adoption_tertiary: 59.52,
      adoption_quaternary: 61.61,
      iso: 'AE',
    },
    {
      position: 3,
      country: 'Singapore',
      downloads_primary: 3142042,
      downloads_secondary: 2170865,
      downloads_tertiary: 2874601,
      downloads_quaternary: 945425,
      population: 5850000,
      adoption_primary: 53.71,
      adoption_secondary: 37.11,
      adoption_tertiary: 49.14,
      adoption_quaternary: 16.16,
      iso: 'SG',
    },
    {
      position: 4,
      country: 'Oman',
      downloads_primary: 1986271,
      downloads_secondary: 1356303,
      downloads_tertiary: 1718353,
      downloads_quaternary: 1805478,
      population: 5110000,
      adoption_primary: 38.87,
      adoption_secondary: 26.54,
      adoption_tertiary: 33.65,
      adoption_quaternary: 35.36,
      iso: 'OM',
    },
    {
      position: 5,
      country: 'Netherlands',
      downloads_primary: 5032830,
      downloads_secondary: 4093890,
      downloads_tertiary: 2801098,
      downloads_quaternary: 1639583,
      population: 17130000,
      adoption_primary: 29.38,
      adoption_secondary: 23.9,
      adoption_tertiary: 16.35,
      adoption_quaternary: 9.57,
      iso: 'NL',
    },
    {
      position: 6,
      country: 'Saudi Arabia',
      downloads_primary: 10044842,
      downloads_secondary: 9419488,
      downloads_tertiary: 12760979,
      downloads_quaternary: 10081329,
      population: 34810000,
      adoption_primary: 28.86,
      adoption_secondary: 27.06,
      adoption_tertiary: 36.65,
      adoption_quaternary: 28.96,
      iso: 'SA',
    },
    {
      position: 7,
      country: 'Kuwait',
      downloads_primary: 1075914,
      downloads_secondary: 818069,
      downloads_tertiary: 1265560,
      downloads_quaternary: 933664,
      population: 4270000,
      adoption_primary: 25.2,
      adoption_secondary: 19.16,
      adoption_tertiary: 29.63,
      adoption_quaternary: 21.86,
      iso: 'KW',
    },
    {
      position: 8,
      country: 'Turkey',
      downloads_primary: 14398181,
      downloads_secondary: 12390300,
      downloads_tertiary: 19020753,
      downloads_quaternary: 9449156,
      population: 84340000,
      adoption_primary: 17.07,
      adoption_secondary: 14.69,
      adoption_tertiary: 22.55,
      adoption_quaternary: 11.2,
      iso: 'TR',
    },
    {
      position: 9,
      country: 'France',
      downloads_primary: 10534433,
      downloads_secondary: 8907640,
      downloads_tertiary: 6017733,
      downloads_quaternary: 3425823,
      population: 65269999.99999999,
      adoption_primary: 16.14,
      adoption_secondary: 13.65,
      adoption_tertiary: 9.22,
      adoption_quaternary: 5.25,
      iso: 'FR',
    },
    {
      position: 10,
      country: 'Australia',
      downloads_primary: 3988989,
      downloads_secondary: 2581455,
      downloads_tertiary: 2503351,
      downloads_quaternary: 2498393,
      population: 25500000,
      adoption_primary: 15.64,
      adoption_secondary: 10.12,
      adoption_tertiary: 9.82,
      adoption_quaternary: 9.8,
      iso: 'AU',
    },
    {
      position: 11,
      country: 'Canada',
      downloads_primary: 5475547,
      downloads_secondary: 4627684,
      downloads_tertiary: 3990795,
      downloads_quaternary: 3432173,
      population: 37740000,
      adoption_primary: 14.51,
      adoption_secondary: 12.26,
      adoption_tertiary: 10.57,
      adoption_quaternary: 9.09,
      iso: 'CA',
    },
    {
      position: 12,
      country: 'Germany',
      downloads_primary: 11848528,
      downloads_secondary: 11949094,
      downloads_tertiary: 7551170,
      downloads_quaternary: 3678660,
      population: 83780000,
      adoption_primary: 14.14,
      adoption_secondary: 14.26,
      adoption_tertiary: 9.01,
      adoption_quaternary: 4.39,
      iso: 'DE',
    },
    {
      position: 13,
      country: 'Hong Kong',
      downloads_primary: 1057836,
      downloads_secondary: 1066180,
      downloads_tertiary: 893865,
      downloads_quaternary: 730656,
      population: 7500000,
      adoption_primary: 14.1,
      adoption_secondary: 14.22,
      adoption_tertiary: 11.92,
      adoption_quaternary: 9.75,
      iso: 'HK',
    },
    {
      position: 14,
      country: 'UK',
      downloads_primary: 9524013,
      downloads_secondary: 12390330,
      downloads_tertiary: 10055282,
      downloads_quaternary: 8192613,
      population: 67890000,
      adoption_primary: 14.03,
      adoption_secondary: 18.25,
      adoption_tertiary: 14.81,
      adoption_quaternary: 12.07,
      iso: 'GB',
    },
    {
      position: 15,
      country: 'South Korea',
      downloads_primary: 7060799,
      downloads_secondary: 4204840,
      downloads_tertiary: 5130451,
      downloads_quaternary: 4470980,
      population: 51270000,
      adoption_primary: 13.77,
      adoption_secondary: 8.2,
      adoption_tertiary: 10.01,
      adoption_quaternary: 8.72,
      iso: 'KR',
    },
    {
      position: 16,
      country: 'New Zealand',
      downloads_primary: 651559,
      downloads_secondary: 537298,
      downloads_tertiary: 496361,
      downloads_quaternary: 481086,
      population: 4820000,
      adoption_primary: 13.52,
      adoption_secondary: 11.15,
      adoption_tertiary: 10.29,
      adoption_quaternary: 9.98,
      iso: 'NZ',
    },
    {
      position: 17,
      country: 'United States',
      downloads_primary: 42487213,
      downloads_secondary: 48743821,
      downloads_tertiary: 53130805,
      downloads_quaternary: 38117671,
      population: 331000000,
      adoption_primary: 12.84,
      adoption_secondary: 14.73,
      adoption_tertiary: 16.05,
      adoption_quaternary: 11.52,
      iso: 'US',
    },
    {
      position: 18,
      country: 'Ireland',
      downloads_primary: 634790,
      downloads_secondary: 554820,
      downloads_tertiary: 657646,
      downloads_quaternary: 517908,
      population: 5060000,
      adoption_primary: 12.55,
      adoption_secondary: 10.96,
      adoption_tertiary: 13,
      adoption_quaternary: 10.24,
      iso: 'IE',
    },
    {
      position: 19,
      country: 'Pakistan',
      downloads_primary: 27622389,
      downloads_secondary: 17345605,
      downloads_tertiary: 65370311,
      downloads_quaternary: 13259084,
      population: 220890000,
      adoption_primary: 12.51,
      adoption_secondary: 7.85,
      adoption_tertiary: 29.59,
      adoption_quaternary: 6,
      iso: 'PK',
    },
    {
      position: 20,
      country: 'Iceland',
      downloads_primary: 46466,
      downloads_secondary: null,
      downloads_tertiary: null,
      downloads_quaternary: null,
      population: 372520,
      adoption_primary: 12.47,
      adoption_secondary: null,
      adoption_tertiary: null,
      adoption_quaternary: null,
      iso: 'IS',
    },
    {
      position: 21,
      country: 'Kazakhstan',
      downloads_primary: 2252955,
      downloads_secondary: 2742469,
      downloads_tertiary: 5195865,
      downloads_quaternary: 1187838,
      population: 18780000,
      adoption_primary: 12,
      adoption_secondary: 14.6,
      adoption_tertiary: 28,
      adoption_quaternary: 6.33,
      iso: 'KZ',
    },
    {
      position: 22,
      country: 'Switzerland',
      downloads_primary: 980213,
      downloads_secondary: 774160,
      downloads_tertiary: 569051,
      downloads_quaternary: 369513,
      population: 8950000,
      adoption_primary: 10.95,
      adoption_secondary: 8.65,
      adoption_tertiary: 6.36,
      adoption_quaternary: 4.13,
      iso: 'CH',
    },
    {
      position: 23,
      country: 'Indonesia',
      downloads_primary: 29009868,
      downloads_secondary: 21273984,
      downloads_tertiary: 60356339,
      downloads_quaternary: 41960387,
      population: 273520000,
      adoption_primary: 10.61,
      adoption_secondary: 7.78,
      adoption_tertiary: 22.07,
      adoption_quaternary: 15.34,
      iso: 'ID',
    },
    {
      position: 24,
      country: 'Malaysia',
      downloads_primary: 3315029,
      downloads_secondary: 3336482,
      downloads_tertiary: 7149694,
      downloads_quaternary: 2959597,
      population: 32369999.999999996,
      adoption_primary: 10.24,
      adoption_secondary: 10.31,
      adoption_tertiary: 22.09,
      adoption_quaternary: 9.14,
      iso: 'MY',
    },
    {
      position: 25,
      country: 'Luxembourg',
      downloads_primary: 63540,
      downloads_secondary: 144007,
      downloads_tertiary: 102115,
      downloads_quaternary: 55619,
      population: 625980,
      adoption_primary: 10.15,
      adoption_secondary: 23.01,
      adoption_tertiary: 16.31,
      adoption_quaternary: 8.89,
      iso: 'LU',
    },
    {
      position: 26,
      country: 'Lithuania',
      downloads_primary: 273908,
      downloads_secondary: 267596,
      downloads_tertiary: 257984,
      downloads_quaternary: 139488,
      population: 2720000,
      adoption_primary: 10.07,
      adoption_secondary: 9.84,
      adoption_tertiary: 9.48,
      adoption_quaternary: 5.12,
      iso: 'LT',
    },
    {
      position: 27,
      country: 'Latvia',
      downloads_primary: 186873,
      downloads_secondary: 203059,
      downloads_tertiary: 151135,
      downloads_quaternary: 71012,
      population: 1890000,
      adoption_primary: 9.89,
      adoption_secondary: 10.74,
      adoption_tertiary: 8.01,
      adoption_quaternary: 3.76,
      iso: 'LV',
    },
    {
      position: 28,
      country: 'Belgium',
      downloads_primary: 1116876,
      downloads_secondary: 1114426,
      downloads_tertiary: 915717,
      downloads_quaternary: 609222,
      population: 11590000,
      adoption_primary: 9.64,
      adoption_secondary: 9.62,
      adoption_tertiary: 7.9,
      adoption_quaternary: 5.26,
      iso: 'BE',
    },
    {
      position: 29,
      country: 'Sweden',
      downloads_primary: 946389,
      downloads_secondary: 952609,
      downloads_tertiary: 790004,
      downloads_quaternary: 553703,
      population: 10100000,
      adoption_primary: 9.37,
      adoption_secondary: 9.43,
      adoption_tertiary: 7.82,
      adoption_quaternary: 5.48,
      iso: 'SE',
    },
    {
      position: 30,
      country: 'Belarus',
      downloads_primary: 874028,
      downloads_secondary: 995481,
      downloads_tertiary: 1184939,
      downloads_quaternary: 634846,
      population: 9450000,
      adoption_primary: 9.25,
      adoption_secondary: 10.53,
      adoption_tertiary: 12.54,
      adoption_quaternary: 6.72,
      iso: 'BY',
    },
    {
      position: 31,
      country: 'Israel',
      downloads_primary: 792333,
      downloads_secondary: 641301,
      downloads_tertiary: 986309,
      downloads_quaternary: 680697,
      population: 8660000,
      adoption_primary: 9.15,
      adoption_secondary: 7.41,
      adoption_tertiary: 11.4,
      adoption_quaternary: 7.86,
      iso: 'IL',
    },
    {
      position: 32,
      country: 'Norway',
      downloads_primary: 493511,
      downloads_secondary: 438091,
      downloads_tertiary: 363835,
      downloads_quaternary: 302894,
      population: 5420000,
      adoption_primary: 9.11,
      adoption_secondary: 8.08,
      adoption_tertiary: 6.71,
      adoption_quaternary: 5.59,
      iso: 'NO',
    },
    {
      position: 33,
      country: 'Ukraine',
      downloads_primary: 3975823,
      downloads_secondary: 7514770,
      downloads_tertiary: 7121198,
      downloads_quaternary: 3442970,
      population: 43730000,
      adoption_primary: 9.09,
      adoption_secondary: 17.18,
      adoption_tertiary: 16.28,
      adoption_quaternary: 7.87,
      iso: 'UA',
    },
    {
      position: 34,
      country: 'Portugal',
      downloads_primary: 897331,
      downloads_secondary: 984746,
      downloads_tertiary: 1056597,
      downloads_quaternary: 669379,
      population: 10200000,
      adoption_primary: 8.8,
      adoption_secondary: 9.65,
      adoption_tertiary: 10.36,
      adoption_quaternary: 6.56,
      iso: 'PT',
    },
    {
      position: 35,
      country: 'Estonia',
      downloads_primary: 108872,
      downloads_secondary: 107605,
      downloads_tertiary: 92729,
      downloads_quaternary: 62941,
      population: 1330000,
      adoption_primary: 8.19,
      adoption_secondary: 8.09,
      adoption_tertiary: 6.99,
      adoption_quaternary: 4.74,
      iso: 'EE',
    },
    {
      position: 36,
      country: 'Austria',
      downloads_primary: 720129,
      downloads_secondary: 676710,
      downloads_tertiary: 560246,
      downloads_quaternary: 295229,
      population: 9010000,
      adoption_primary: 7.99,
      adoption_secondary: 7.51,
      adoption_tertiary: 6.22,
      adoption_quaternary: 3.28,
      iso: 'AT',
    },
    {
      position: 37,
      country: 'Croatia',
      downloads_primary: 303909,
      downloads_secondary: 237384,
      downloads_tertiary: 308887,
      downloads_quaternary: 169257,
      population: 4110000.0000000005,
      adoption_primary: 7.39,
      adoption_secondary: 5.78,
      adoption_tertiary: 7.52,
      adoption_quaternary: 4.12,
      iso: 'HR',
    },
    {
      position: 38,
      country: 'Finland',
      downloads_primary: 388628,
      downloads_secondary: 398644,
      downloads_tertiary: 277578,
      downloads_quaternary: 271266,
      population: 5540000,
      adoption_primary: 7.01,
      adoption_secondary: 7.2,
      adoption_tertiary: 5.01,
      adoption_quaternary: 4.9,
      iso: 'FI',
    },
    {
      position: 39,
      country: 'Taiwan',
      downloads_primary: 1584351,
      downloads_secondary: 1049837,
      downloads_tertiary: 1211894,
      downloads_quaternary: 629805,
      population: 24210000,
      adoption_primary: 6.54,
      adoption_secondary: 4.34,
      adoption_tertiary: 5.01,
      adoption_quaternary: 2.6,
      iso: 'TW',
    },
    {
      position: 40,
      country: 'Slovakia',
      downloads_primary: 348991,
      downloads_secondary: 301951,
      downloads_tertiary: 358566,
      downloads_quaternary: 162005,
      population: 5460000,
      adoption_primary: 6.39,
      adoption_secondary: 5.53,
      adoption_tertiary: 6.57,
      adoption_quaternary: 2.97,
      iso: 'SK',
    },
    {
      position: 41,
      country: 'Denmark',
      downloads_primary: 359118,
      downloads_secondary: 402854,
      downloads_tertiary: 318215,
      downloads_quaternary: 278784,
      population: 5790000,
      adoption_primary: 6.2,
      adoption_secondary: 6.96,
      adoption_tertiary: 5.49,
      adoption_quaternary: 4.81,
      iso: 'DK',
    },
    {
      position: 42,
      country: 'Spain',
      downloads_primary: 2830952,
      downloads_secondary: 3658616,
      downloads_tertiary: 2945038,
      downloads_quaternary: 1998460,
      population: 46750000,
      adoption_primary: 6.06,
      adoption_secondary: 7.83,
      adoption_tertiary: 6.3,
      adoption_quaternary: 4.27,
      iso: 'ES',
    },
    {
      position: 43,
      country: 'Lebanon',
      downloads_primary: 409844,
      downloads_secondary: 519372,
      downloads_tertiary: 1672750,
      downloads_quaternary: 435478,
      population: 6830000,
      adoption_primary: 6,
      adoption_secondary: 7.6,
      adoption_tertiary: 24.51,
      adoption_quaternary: 6.38,
      iso: 'LB',
    },
    {
      position: 44,
      country: 'Russia',
      downloads_primary: 8648090,
      downloads_secondary: 33540600,
      downloads_tertiary: 12585576,
      downloads_quaternary: 4920651,
      population: 145930000,
      adoption_primary: 5.93,
      adoption_secondary: 22.98,
      adoption_tertiary: 8.62,
      adoption_quaternary: 3.37,
      iso: 'RU',
    },
    {
      position: 45,
      country: 'Vietnam',
      downloads_primary: 5578930,
      downloads_secondary: 5167305,
      downloads_tertiary: 12079080,
      downloads_quaternary: 3262426,
      population: 97340000,
      adoption_primary: 5.73,
      adoption_secondary: 5.31,
      adoption_tertiary: 12.41,
      adoption_quaternary: 3.35,
      iso: 'VN',
    },
    {
      position: 46,
      country: 'Italy',
      downloads_primary: 3420267,
      downloads_secondary: 4200384,
      downloads_tertiary: 3880248,
      downloads_quaternary: 2641222,
      population: 60460000,
      adoption_primary: 5.66,
      adoption_secondary: 6.95,
      adoption_tertiary: 6.42,
      adoption_quaternary: 4.37,
      iso: 'IT',
    },
    {
      position: 47,
      country: 'Czech Republic',
      downloads_primary: 591920,
      downloads_secondary: 652157,
      downloads_tertiary: 570247,
      downloads_quaternary: 335437,
      population: 10710000,
      adoption_primary: 5.53,
      adoption_secondary: 6.09,
      adoption_tertiary: 5.32,
      adoption_quaternary: 3.13,
      iso: 'CZ',
    },
    {
      position: 48,
      country: 'Greece',
      downloads_primary: 567201,
      downloads_secondary: 828647,
      downloads_tertiary: 864267,
      downloads_quaternary: 372716,
      population: 10420000,
      adoption_primary: 5.44,
      adoption_secondary: 7.95,
      adoption_tertiary: 8.29,
      adoption_quaternary: 3.58,
      iso: 'GR',
    },
    {
      position: 49,
      country: 'Venezuela',
      downloads_primary: 1520321,
      downloads_secondary: 1098201,
      downloads_tertiary: 5709719,
      downloads_quaternary: 912259,
      population: 28440000,
      adoption_primary: 5.35,
      adoption_secondary: 3.86,
      adoption_tertiary: 20.08,
      adoption_quaternary: 3.21,
      iso: 'VE',
    },
    {
      position: 50,
      country: 'Algeria',
      downloads_primary: 2209287,
      downloads_secondary: 3190397,
      downloads_tertiary: 12032632,
      downloads_quaternary: 3143209,
      population: 43850000,
      adoption_primary: 5.04,
      adoption_secondary: 7.28,
      adoption_tertiary: 27.44,
      adoption_quaternary: 7.17,
      iso: 'DZ',
    },
    {
      position: 51,
      country: 'Uruguay',
      downloads_primary: 173773,
      downloads_secondary: 251528,
      downloads_tertiary: 584991,
      downloads_quaternary: 157187,
      population: 3470000,
      adoption_primary: 5.01,
      adoption_secondary: 7.25,
      adoption_tertiary: 16.84,
      adoption_quaternary: 4.53,
      iso: 'UY',
    },
    {
      position: 52,
      country: 'Poland',
      downloads_primary: 1831474,
      downloads_secondary: 2214374,
      downloads_tertiary: 1581402,
      downloads_quaternary: 998726,
      population: 37850000,
      adoption_primary: 4.84,
      adoption_secondary: 5.85,
      adoption_tertiary: 4.18,
      adoption_quaternary: 2.64,
      iso: 'PL',
    },
    {
      position: 53,
      country: 'Romania',
      downloads_primary: 914475,
      downloads_secondary: 1086094,
      downloads_tertiary: 1619518,
      downloads_quaternary: 562179,
      population: 19240000,
      adoption_primary: 4.75,
      adoption_secondary: 5.64,
      adoption_tertiary: 8.42,
      adoption_quaternary: 2.92,
      iso: 'RO',
    },
    {
      position: 54,
      country: 'Chile',
      downloads_primary: 817164,
      downloads_secondary: 1741358,
      downloads_tertiary: 2366039,
      downloads_quaternary: 956736,
      population: 19120000,
      adoption_primary: 4.27,
      adoption_secondary: 9.11,
      adoption_tertiary: 12.38,
      adoption_quaternary: 5,
      iso: 'CL',
    },
    {
      position: 55,
      country: 'Ecuador',
      downloads_primary: 693376,
      downloads_secondary: 1449905,
      downloads_tertiary: 3996522,
      downloads_quaternary: 626173,
      population: 17640000,
      adoption_primary: 3.93,
      adoption_secondary: 8.22,
      adoption_tertiary: 22.65,
      adoption_quaternary: 4,
      iso: 'EC',
    },
    {
      position: 56,
      country: 'Colombia',
      downloads_primary: 1915820,
      downloads_secondary: 3184253,
      downloads_tertiary: 9385406,
      downloads_quaternary: 1492397,
      population: 50880000,
      adoption_primary: 3.77,
      adoption_secondary: 6.26,
      adoption_tertiary: 18.45,
      adoption_quaternary: 2.93,
      iso: 'CO',
    },
    {
      position: 57,
      country: 'Bulgaria',
      downloads_primary: 260825,
      downloads_secondary: 322468,
      downloads_tertiary: 442721,
      downloads_quaternary: 164775,
      population: 6950000,
      adoption_primary: 3.75,
      adoption_secondary: 4.64,
      adoption_tertiary: 6.37,
      adoption_quaternary: 2.37,
      iso: 'BG',
    },
    {
      position: 58,
      country: 'Argentina',
      downloads_primary: 1694136,
      downloads_secondary: 3032688,
      downloads_tertiary: 7264811,
      downloads_quaternary: 2372693,
      population: 45200000,
      adoption_primary: 3.75,
      adoption_secondary: 6.71,
      adoption_tertiary: 16.07,
      adoption_quaternary: 5.25,
      iso: 'AR',
    },
    {
      position: 59,
      country: 'Philippines',
      downloads_primary: 4080533,
      downloads_secondary: 6035673,
      downloads_tertiary: 15514314,
      downloads_quaternary: 7265777,
      population: 109580000,
      adoption_primary: 3.72,
      adoption_secondary: 5.51,
      adoption_tertiary: 14.16,
      adoption_quaternary: 6.63,
      iso: 'PH',
    },
    {
      position: 60,
      country: 'Slovenia',
      downloads_primary: 73394,
      downloads_secondary: 99335,
      downloads_tertiary: 121450,
      downloads_quaternary: 56448,
      population: 2080000,
      adoption_primary: 3.53,
      adoption_secondary: 4.78,
      adoption_tertiary: 5.84,
      adoption_quaternary: 2.72,
      iso: 'SI',
    },
    {
      position: 61,
      country: 'Brazil',
      downloads_primary: 7486596,
      downloads_secondary: 11856644,
      downloads_tertiary: 23167788,
      downloads_quaternary: 9677209,
      population: 212560000,
      adoption_primary: 3.52,
      adoption_secondary: 5.58,
      adoption_tertiary: 10.9,
      adoption_quaternary: 4.55,
      iso: 'BR',
    },
    {
      position: 62,
      country: 'Nigeria',
      downloads_primary: 7088347,
      downloads_secondary: 7152889,
      downloads_tertiary: 14289099,
      downloads_quaternary: 3351521,
      population: 206140000,
      adoption_primary: 3.44,
      adoption_secondary: 3.47,
      adoption_tertiary: 6.93,
      adoption_quaternary: 1.63,
      iso: 'NG',
    },
    {
      position: 63,
      country: 'Hungary',
      downloads_primary: 330408,
      downloads_secondary: 631903,
      downloads_tertiary: 844656,
      downloads_quaternary: 283829,
      population: 9660000,
      adoption_primary: 3.42,
      adoption_secondary: 6.54,
      adoption_tertiary: 8.74,
      adoption_quaternary: 2.94,
      iso: 'HU',
    },
    {
      position: 64,
      country: 'Mexico',
      downloads_primary: 4379938,
      downloads_secondary: 7040127,
      downloads_tertiary: 14589336,
      downloads_quaternary: 4262070,
      population: 128930000,
      adoption_primary: 3.4,
      adoption_secondary: 5.46,
      adoption_tertiary: 11.32,
      adoption_quaternary: 3.31,
      iso: 'MX',
    },
    {
      position: 65,
      country: 'India',
      downloads_primary: 46456750,
      downloads_secondary: 48892979,
      downloads_tertiary: 277152450,
      downloads_quaternary: 45248196,
      population: 1380000000,
      adoption_primary: 3.37,
      adoption_secondary: 3.54,
      adoption_tertiary: 20.08,
      adoption_quaternary: 3.28,
      iso: 'IN',
    },
    {
      position: 66,
      country: 'Egypt',
      downloads_primary: 2956920,
      downloads_secondary: 3902398,
      downloads_tertiary: 15016374,
      downloads_quaternary: 2897635,
      population: 102330000,
      adoption_primary: 2.89,
      adoption_secondary: 3.81,
      adoption_tertiary: 14.67,
      adoption_quaternary: 2.83,
      iso: 'EG',
    },
    {
      position: 67,
      country: 'Tunisia',
      downloads_primary: 325445,
      downloads_secondary: 575382,
      downloads_tertiary: 2671136,
      downloads_quaternary: 591643,
      population: 11820000,
      adoption_primary: 2.75,
      adoption_secondary: 4.87,
      adoption_tertiary: 22.6,
      adoption_quaternary: 5.01,
      iso: 'TN',
    },
    {
      position: 68,
      country: 'Peru',
      downloads_primary: 845053,
      downloads_secondary: 1637077,
      downloads_tertiary: 5002791,
      downloads_quaternary: 1016430,
      population: 32970000,
      adoption_primary: 2.56,
      adoption_secondary: 4.97,
      adoption_tertiary: 15.17,
      adoption_quaternary: 3.08,
      iso: 'PE',
    },
    {
      position: 69,
      country: 'Thailand',
      downloads_primary: 1784197,
      downloads_secondary: 1334946,
      downloads_tertiary: 4861890,
      downloads_quaternary: 1487880,
      population: 69800000,
      adoption_primary: 2.56,
      adoption_secondary: 1.91,
      adoption_tertiary: 6.97,
      adoption_quaternary: 2.13,
      iso: 'TH',
    },
    {
      position: 70,
      country: 'Kenya',
      downloads_primary: 1030847,
      downloads_secondary: null,
      downloads_tertiary: 2680954,
      downloads_quaternary: 271979,
      population: 53770000,
      adoption_primary: 1.92,
      adoption_secondary: null,
      adoption_tertiary: 4.99,
      adoption_quaternary: 0.51,
      iso: 'KE',
    },
    {
      position: 71,
      country: 'Japan',
      downloads_primary: 2314056,
      downloads_secondary: 1872041,
      downloads_tertiary: 1972875,
      downloads_quaternary: 1383635,
      population: 126480000,
      adoption_primary: 1.83,
      adoption_secondary: 1.48,
      adoption_tertiary: 1.56,
      adoption_quaternary: 1.09,
      iso: 'JP',
    },
    {
      position: 72,
      country: 'South Africa',
      downloads_primary: 857553,
      downloads_secondary: 2270430,
      downloads_tertiary: 2365233,
      downloads_quaternary: 781806,
      population: 59730000,
      adoption_primary: 1.44,
      adoption_secondary: 3.8,
      adoption_tertiary: 3.96,
      adoption_quaternary: 1.31,
      iso: 'ZA',
    },
    {
      position: 73,
      country: 'Bolivia',
      downloads_primary: null,
      downloads_secondary: null,
      downloads_tertiary: 3152877,
      downloads_quaternary: 284040,
      population: 11670000,
      adoption_primary: null,
      adoption_secondary: null,
      adoption_tertiary: 27.01,
      adoption_quaternary: 2.43,
      iso: 'BO',
    },
    {
      position: 74,
      country: 'El Salvador',
      downloads_primary: null,
      downloads_secondary: null,
      downloads_tertiary: 1499446,
      downloads_quaternary: 199088,
      population: 6490000,
      adoption_primary: null,
      adoption_secondary: null,
      adoption_tertiary: 23.12,
      adoption_quaternary: 3.07,
      iso: 'SV',
    },
    {
      position: 75,
      country: 'Costa Rica',
      downloads_primary: null,
      downloads_secondary: null,
      downloads_tertiary: 1122181,
      downloads_quaternary: 212319,
      population: 5090000,
      adoption_primary: null,
      adoption_secondary: null,
      adoption_tertiary: 22.03,
      adoption_quaternary: 4.17,
      iso: 'CR',
    },
    {
      position: 76,
      country: 'Dominican Republic',
      downloads_primary: null,
      downloads_secondary: null,
      downloads_tertiary: 2504443,
      downloads_quaternary: 515755,
      population: 11400000,
      adoption_primary: null,
      adoption_secondary: null,
      adoption_tertiary: 21.96,
      adoption_quaternary: 4.52,
      iso: 'DO',
    },
    {
      position: 77,
      country: 'Panama',
      downloads_primary: null,
      downloads_secondary: null,
      downloads_tertiary: 820424,
      downloads_quaternary: 327896,
      population: 4310000,
      adoption_primary: null,
      adoption_secondary: null,
      adoption_tertiary: 19.01,
      adoption_quaternary: 7.6,
      iso: 'PA',
    },
    {
      position: 78,
      country: 'Nicaragua',
      downloads_primary: null,
      downloads_secondary: null,
      downloads_tertiary: 1188911,
      downloads_quaternary: 193427,
      population: 6620000,
      adoption_primary: null,
      adoption_secondary: null,
      adoption_tertiary: 17.95,
      adoption_quaternary: 2.92,
      iso: 'NI',
    },
    {
      position: 79,
      country: 'Uzbekistan',
      downloads_primary: null,
      downloads_secondary: null,
      downloads_tertiary: 5933467,
      downloads_quaternary: 611417,
      population: 33470000,
      adoption_primary: null,
      adoption_secondary: null,
      adoption_tertiary: 17.73,
      adoption_quaternary: 2,
      iso: 'UZ',
    },
    {
      position: 80,
      country: 'Cambodia',
      downloads_primary: null,
      downloads_secondary: null,
      downloads_tertiary: 2912190,
      downloads_quaternary: 342034,
      population: 16719999.999999998,
      adoption_primary: null,
      adoption_secondary: null,
      adoption_tertiary: 17.42,
      adoption_quaternary: 2.05,
      iso: 'KH',
    },
    {
      position: 81,
      country: 'Paraguay',
      downloads_primary: null,
      downloads_secondary: null,
      downloads_tertiary: 1235502,
      downloads_quaternary: 356625,
      population: 7130000,
      adoption_primary: null,
      adoption_secondary: null,
      adoption_tertiary: 17.32,
      adoption_quaternary: 5,
      iso: 'PY',
    },
    {
      position: 82,
      country: 'Guatemala',
      downloads_primary: null,
      downloads_secondary: null,
      downloads_tertiary: 2806958,
      downloads_quaternary: 449685,
      population: 17920000,
      adoption_primary: null,
      adoption_secondary: null,
      adoption_tertiary: 15.67,
      adoption_quaternary: 2.51,
      iso: 'GT',
    },
    {
      position: 83,
      country: 'Azerbaijan',
      downloads_primary: null,
      downloads_secondary: null,
      downloads_tertiary: 1561842,
      downloads_quaternary: 2267024,
      population: 10140000,
      adoption_primary: null,
      adoption_secondary: null,
      adoption_tertiary: 15.4,
      adoption_quaternary: 22.36,
      iso: 'AZ',
    },
    {
      position: 84,
      country: 'Sri Lanka',
      downloads_primary: null,
      downloads_secondary: null,
      downloads_tertiary: 2705252,
      downloads_quaternary: 409859,
      population: 21410000,
      adoption_primary: null,
      adoption_secondary: null,
      adoption_tertiary: 12.63,
      adoption_quaternary: 1.91,
      iso: 'LK',
    },
    {
      position: 85,
      country: 'Ghana',
      downloads_primary: null,
      downloads_secondary: null,
      downloads_tertiary: 3586121,
      downloads_quaternary: 405105,
      population: 31260000,
      adoption_primary: null,
      adoption_secondary: null,
      adoption_tertiary: 11.47,
      adoption_quaternary: 1.3,
      iso: 'GH',
    },
    {
      position: 86,
      country: 'Madagascar',
      downloads_primary: null,
      downloads_secondary: null,
      downloads_tertiary: 217476,
      downloads_quaternary: 36259,
      population: 27690000,
      adoption_primary: null,
      adoption_secondary: null,
      adoption_tertiary: 0.79,
      adoption_quaternary: 0.13,
      iso: 'MG',
    },
  ],
});

export const PAGE_DATA = {
  metaData: (t) => ({
    title: t('vpnAdoptionIndex:metaData.title', { year: new Date().getFullYear() }),
    description: t('vpnAdoptionIndex:metaData.description'),
    image: META_IMAGE,
  }),
  header: (t) => ({
    title: t('vpnAdoptionIndex:header.title'),
    description: t('vpnAdoptionIndex:header.description'),
    image: ImageTop,
    imageMobile: ImageTopMobile,
  }),
  about: (t) => ({
    title: t('vpnAdoptionIndex:about.title'),
    description: t('vpnAdoptionIndex:about.description', {
      yearPeriodQuaternary: YEAR_PERIOD_2020,
      yearPeriodTertiary: YEAR_PERIOD_2021,
      yearPeriodSecondary: YEAR_PERIOD_2022,
      yearPeriodPrimary: YEAR_PERIOD_2023,
      numOfMillionsQuaternary: 277,
      numOfMillionsTertiary: 785,
      numOfMillionsSecondary: 353,
      numOfMillionsPrimary: 328,
      countryCount: COUNTRY_COUNT,
    }),
    image: ImageBottom,
    imageMobile: ImageBottomMobile,
  }),
  countryRatings: (t) => ({
    titleHighest: t('vpnAdoptionIndex:countryRatings.titleHighest'),
    imageHighest: {
      src: ImageHighest,
      alt: 'Arrow up',
    },
    titleLowest: t('vpnAdoptionIndex:countryRatings.titleLowest'),
    imageLowest: {
      src: ImageLowest,
      alt: 'Arrow down',
    },
    description: t('vpnAdoptionIndex:countryRatings.description', {
      yearPeriod: YEAR_PERIOD_2023,
    }),
  }),
  methodology: (t) => ({
    title: t('vpnAdoptionIndex:methodology.title'),
    description: t('vpnAdoptionIndex:methodology.description', {
      yearPeriodFrom: YEAR_PERIOD_2020,
      yearPeriodTo: YEAR_PERIOD_2023,
      countryCount: COUNTRY_COUNT,
      vpnProvidersCount: 45,
    }),
  }),
  footer: (t) => ({ title: t('vpnAdoptionIndex:footer.title') }),
};
